export const SET_SERVICE_STATUS = 'setServiceStatus'
export const SET_ACCOUNT = 'setAccount'
export const SET_COMPANIES = 'setCompanies'
export const SET_ITEM_CATEGORY_LEVELS = 'setItemCategoryLevels'
export const SET_MENUS = 'setMenus'
export const SET_CALENDAR = 'setCalendar'
export const SET_ANNOUNCEMENT = 'setAnnouncement'
export const ENABLE_SEASON_FEATURE = 'setEnableSeasonFeature'
export const SET_OUTPUT_COLUMNS = 'setOutputColumns'
